import { render, staticRenderFns } from "./result_image_link_setting.vue?vue&type=template&id=7b5ec3cc&lang=pug&"
import script from "./result_image_link_setting.vue?vue&type=script&lang=js&"
export * from "./result_image_link_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports